import { TextareaAutosize } from '@mui/material';
import { useState, useEffect } from 'react';


const defaultSampleResponse = {
  header: {
    title: "Sample Title",
    subtitle: "Sample Subtitle",
    body: "Sample Body",
  },
  footer: {
    title: "Sample Title",
    subtitle: "Sample Subtitle",
    body: "Sample Body",
  },
  items: [{
    title: "Sample Title",
    subtitle: "Sample Subtitle",
    body: "Sample Body",
  },
  {
    title: "Sample Title",
    subtitle: "Sample Subtitle",
    body: "Sample Body",
  }]
}

function SampleResponse({template, setTemplate}) {
  const [sampleResponse, setSampleResponse] = useState(JSON.stringify(template.sample_response, null, 2) || JSON.stringify(defaultSampleResponse, null, 2));

  useEffect(() => {

    if (template?.data_template_json && !sampleResponse) {
      setSampleResponse(JSON.stringify(generateSample(template.data_template_json), null, 2));
    }
  }, [template]);

  useEffect(() => {
    if (!template) return;

    try {
      const parsedSampleResponse = JSON.parse(sampleResponse);
      const schema = toJsonSchema(parsedSampleResponse);  
      template.data_template_json = schema;
      template.sample_response = parsedSampleResponse;
    } catch (error) {
      template.data_template_json = null;
      console.error(error);
    }
    setTemplate(template);
  }, [sampleResponse]);

  if (!template) return <div>Loading...</div>;
  return (
    <div>
      <h1>Sample Response</h1>
      <TextareaAutosize value={sampleResponse} 
        style={{ width: '80%', height: '500px' }}
        onChange={(e) => {
          setSampleResponse(e.target.value) 
        }} />
      <div style={{
        marginTop: '20px',
      }}>
        <h1>Generated Schema</h1>
        <TextareaAutosize value={JSON.stringify(template.data_template_json, null, 2)} 
          style={{ width: '80%', height: '500px' }}
          onChange={(e) => {
            // setSampleResponse(e.target.value) 
          }} />
      </div>
    </div>
  )
}

function toJsonSchema(definition) {
  if (Array.isArray(definition)) {
    return { type: "array", items: toJsonSchema(definition[0]) };
  } else if (typeof definition === "object") {
    return {
      type: "object",
      properties: Object.fromEntries(
        Object.entries(definition).map(([key, value]) => [key, toJsonSchema(value)])
      ),
      required: Object.keys(definition),
      additionalProperties: false,
    };
  } else if (typeof definition === "string") {
    return { type: "string" };
  }
}

function generateSample(schema) {
  if (!schema || typeof schema !== "object") return null;
  
  if (schema.type === "string") {
    if (schema.format === "email") return "example@example.com";
    if (schema.format === "date") return "2025-01-01";
    if (schema.format === "uuid") return "550e8400-e29b-41d4-a716-446655440000";
    return "sample text";
  }

  if (schema.type === "integer") {
    return schema.minimum !== undefined ? schema.minimum : 42;
  }

  if (schema.type === "number") {
    return schema.minimum !== undefined ? schema.minimum : 3.14;
  }

  if (schema.type === "boolean") {
    return true;
  }

  if (schema.type === "array") {
    return [generateSample(schema.items)];
  }

  if (schema.type === "object") {
    const obj = {};
    if (schema.properties) {
      for (const [key, value] of Object.entries(schema.properties)) {
        obj[key] = generateSample(value);
      }
    }
    return obj;
  }

  return null;
}

export default SampleResponse;